import axios from "axios";
import clientStorage from "./clientStorage";
import { APP_BASE_PATH } from "./appConfig";

export default class api {
  static async getCourses() {
    return await axios({
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${clientStorage.getAuthToken()}`,
      },
      method: "get",
      url: `${APP_BASE_PATH}/Selector/Courses`,
    });
  }

  static async getCoursePublishes(courseId) {
    return await axios({
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${clientStorage.getAuthToken()}`,
      },
      method: "get",
      url: `${APP_BASE_PATH}/Selector/Courses/${courseId}/Publishes`,
    });
  }

  static async getInstructionData(publishKey) {
    return await axios({
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${clientStorage.getAuthToken()}`,
      },
      method: "get",
      url: `${APP_BASE_PATH}/Instruction/${publishKey}/Data`,
    });
  }

  static async setUserProgress(publishKey, progress) {
    return await axios({
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${clientStorage.getAuthToken()}`,
      },
      method: "put",
      url: `${APP_BASE_PATH}/Instruction/${publishKey}/Progress`,
      data: progress,
    });
  }
}
